module.exports = __webpack_public_path__ + "assets/img/get_btn.6857c4e9.png";